import { render, staticRenderFns } from "./noticeWeappAttr.vue?vue&type=template&id=661ebec4&scoped=true"
import script from "./noticeWeappAttr.vue?vue&type=script&lang=js"
export * from "./noticeWeappAttr.vue?vue&type=script&lang=js"
import style0 from "./noticeWeappAttr.vue?vue&type=style&index=0&id=661ebec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ebec4",
  null
  
)

component.options.__file = "noticeWeappAttr.vue"
export default component.exports